import React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import { formatDate, formatDateAsString, formatDateObj, formatMoney, formatTitleCase } from '../../util/formatters';
import { CardLayout } from '../cardLayout/CardLayout';
import { HomeInfoLabel, LayoutContainer } from '../policyInfo/PolicyInfoStyles';
import { OtherInsuredItem } from '../policyInfo/PolicyInfoProperty';
import BounceLoaderComponent from './Loader';

export const Column1 = styled(Box)`
  margin-left: 0;
  margin-right: 33%;
  display: flex;
  flex-direction: column;
  line-height: 1.375rem;
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

export const Column2 = styled(Box)`
  display: flex;
  flex-direction: column;
  line-height: 1.375rem;
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

export const Column3 = styled(Box)`
margin-left: 33%;
margin-right: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.375rem;
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

export const Column4 = styled(Box)`
margin-left: 0;
margin-right: 33%;
  display: flex;
  flex-direction: column;
  line-height: 1.375rem;
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

const RelationSpacer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;
const RelationSpacerCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid green;
`;

const ExcludedSpacing = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: space-between;
  width: 280px;
  gap: 20px;
`;

const ContentSize = styled.div`
  height: 20px;
  width: 80px;
  margin-bottom: 10px;
`;

const OuterLeftWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const LeftWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const WrapperOne = styled.div`
  width: 33%;
  padding: 0.5em;
  margin: 0.5em;
`;

const WrapperTwo = styled.div`
  width: 33%;
  padding: 0.5em;
  margin: 0.5em;
`;

const WrappeThree = styled.div`
  width: 33%;
  padding: 0.5em;
  margin: 0.5em;
`;

const InnerWrapperOne = styled.div`
  width: 100%;
  color: #00008b !important;
  font-weight: 700;
  padding-bottom: 7px;
`;

const InnerWrapperTwo = styled.div`
  width: 100%;
`;

const MainWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const MainLeftWrapper = styled.div`
  width: 75%;
`;

const MainRightWrapper = styled.div`
  width: 25%;
`;

const PremiumWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5em;
`;

const TotalPremiumWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const TotalPremiumText = styled.div`
`;

const TotalPremiumNumber = styled.div`
  align-items: right;
`;

const TotalCostWrapper = styled.div`
  align-items: right;
  font-size: 25px;
  font-weight: bold;
`;

const Hr = styled.div`
  border-top: solid 1px #ddd;
  margin: 0.5em 0 0 0;
`;

interface gpaPolicyInfoProps {
  result: any;
  dataLoading: boolean;
  isMigrated: boolean;
  isMigrating: boolean;
}

export default ({
  result,
  dataLoading,
  isMigrated,
  isMigrating
}: gpaPolicyInfoProps) => {

  if (dataLoading) {
    return <BounceLoaderComponent />;
  };

  return (
    <LayoutContainer>
      <CardLayout title="Policy Information" bodyHeight='auto'>
        <>
          {result ? (
            <>
              <MainWrapper>
                <MainLeftWrapper>
                  <OuterLeftWrapper>
                    <LeftWrapper>
                      <WrapperOne>
                        <InnerWrapperOne>
                          Policy Inception:
                        </InnerWrapperOne>
                        <InnerWrapperTwo>
                          {result?.result?.currentTermStartDate ? formatDateAsString(formatDateObj(result?.result?.currentTermStartDate)) : formatDateAsString(formatDateObj(result?.result?.latestPeriod?.effectiveDate))}
                        </InnerWrapperTwo>
                      </WrapperOne>
                      <WrapperTwo>
                        <InnerWrapperOne>
                          Policy Expiration:
                        </InnerWrapperOne>
                        <InnerWrapperTwo>
                          {result?.result?.currentTermEndDate ? formatDateAsString(formatDateObj(result?.result?.currentTermEndDate)) : formatDateAsString(result?.result?.latestPeriod?.expirationDate)}
                        </InnerWrapperTwo>
                      </WrapperTwo>
                      <WrappeThree>
                        <InnerWrapperOne>
                          Producer of Record
                        </InnerWrapperOne>
                        <InnerWrapperTwo>
                          {result?.result?.latestPeriod?.producerCodeOfRecordOrg ?
                            `${result.result.latestPeriod.producerCodeOfRecordOrg} (${result.result.latestPeriod.producerCodeOfRecord})` : ''}
                        </InnerWrapperTwo>
                      </WrappeThree>
                    </LeftWrapper>
                  </OuterLeftWrapper>
                  <OuterLeftWrapper>
                    <LeftWrapper>
                      <WrapperOne>
                        <InnerWrapperOne>
                          Pre Renewal Direction:
                        </InnerWrapperOne>
                        <InnerWrapperTwo>
                          None
                        </InnerWrapperTwo>
                      </WrapperOne>
                      <WrapperTwo>
                        <InnerWrapperOne>
                          Policy Status:
                        </InnerWrapperOne>
                        <InnerWrapperTwo>
                          {/* TODO: Validate below condition for a policy which is migrated and current term is expired, it should show status as migrated */}
                          {(isMigrated && result?.result?.latestPeriod?.displayStatus === 'Expired') ? 'Migrated' : result?.result?.latestPeriod?.displayStatus || ''}
                        </InnerWrapperTwo>
                      </WrapperTwo>
                      <WrappeThree>
                        <InnerWrapperOne>
                          Producer of Service
                        </InnerWrapperOne>
                        <InnerWrapperTwo>
                          {result?.result?.latestPeriod?.producerCodeOfServiceOrg ?
                            `${result.result.latestPeriod.producerCodeOfServiceOrg} (${result.result.latestPeriod.producerCodeOfService})` : ''}
                        </InnerWrapperTwo>
                      </WrappeThree>
                    </LeftWrapper>
                  </OuterLeftWrapper>
                  <OuterLeftWrapper>
                    <LeftWrapper>
                      <WrapperOne>
                        <InnerWrapperOne>
                          Signature Status:
                        </InnerWrapperOne>
                        <InnerWrapperTwo>
                          {result?.result?.eSignatureStatus || ''}
                        </InnerWrapperTwo>
                      </WrapperOne>
                      {result?.result?.latestPeriod?.agentOfRecordFullName ? (
                        <WrapperTwo>
                          <InnerWrapperOne>
                            Agent Of Record:
                          </InnerWrapperOne>
                          <InnerWrapperTwo>
                            {result?.result?.latestPeriod?.agentOfRecordFullName || ''}
                          </InnerWrapperTwo>
                        </WrapperTwo>
                      ) : (<></>)}
                      <WrappeThree></WrappeThree>
                    </LeftWrapper>
                  </OuterLeftWrapper>
                </MainLeftWrapper>
                {!(isMigrated || isMigrating) && <MainRightWrapper>
                  <PremiumWrapper>
                    <TotalPremiumWrapper>
                      <TotalPremiumText>Total Premium</TotalPremiumText>
                      <TotalPremiumNumber>{result?.result?.latestPeriod?.totalPremium ? formatMoney(result?.result?.latestPeriod?.totalPremium?.amount) : ''}</TotalPremiumNumber>
                    </TotalPremiumWrapper>
                    <TotalPremiumWrapper>
                      <TotalPremiumText>Taxes and Fees</TotalPremiumText>
                      <TotalPremiumNumber>{result?.result?.latestPeriod?.taxesAndFees ? formatMoney(result?.result?.latestPeriod?.taxesAndFees?.amount) : ''}</TotalPremiumNumber>
                    </TotalPremiumWrapper>
                  </PremiumWrapper>
                  <Hr />
                  <PremiumWrapper>
                    <TotalPremiumWrapper>
                      <TotalPremiumText>TOTAL COST</TotalPremiumText>
                      <TotalCostWrapper>{result?.result?.latestPeriod?.totalCost ? formatMoney(result?.result?.latestPeriod?.totalCost?.amount) : ''}</TotalCostWrapper>
                    </TotalPremiumWrapper>
                  </PremiumWrapper>
                </MainRightWrapper>}
              </MainWrapper>
            </>
          ) : <></>}
        </>
      </CardLayout>
    </LayoutContainer>
  );
};
